// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwOrmDataServiceToken, DwOrmDataService, DwQueryHelper, DwSecuritySSOService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwQueryFilter, DwOperator, DwFilterType } from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { GoogleMapsModule } from '@angular/google-maps';
import { AppMetaDataService, LicensesEntity, AppMetaDataLookups, PayJobChangeEntity, EthosUserEntity } from 'src/app/meta-data/app-meta-data.service';
import { flatMap, combineLatest, map, last, debounceTime } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { validateClaimsRequest } from 'msal/lib-commonjs/AuthenticationParameters';
import { AbstractControl, FormControl } from '@angular/forms';
import { ConfigService } from 'src/environments/environment';
import { NumberSequence } from 'ag-grid-community';
import { filter } from 'mathjs';


@DwComponent({
  name: 'ToEmail',
  parentItemName: 'MemoOfRecord',
  componentType: DwComponentType.formSection,
})

@Component({
  selector: 'app-to-email-control',
  templateUrl: 'to-email-component.html'
})
export class ToEmailComponent extends DwSectionBaseComponent<DwComponentSectionPreference> implements OnInit{
  supemail: string = "";
  constructor(
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,

    private messageService:  DwMessagingService) {
      super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    }

    ngOnInit() {
      super.ngOnInit();

      setTimeout(() => this.setupCompanyChange(), 100);
    }

    setupCompanyChange() {
      this.formGroup.get('EmployeeEthos_UserId').valueChanges
        .subscribe(value => {
          this.handleCompanyChange(value);
        });
    }
  handleCompanyChange(value: any) {
    const md = new AppMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.EthosUser.CreateQuery();
    const filter: DwQueryFilter = new DwQueryFilter();
    filter.Attr = md.EthosUser.UserId;
    filter.Value = value;
    filter.Op = DwOperator.And;
    filter.Type = DwFilterType.Equal;
    var supId;
    this.dataService.executeQuery(query.AddFilterAnd(filter)).subscribe(x => {
      const data : EthosUserEntity = x[0];
      supId = data.SupervisorUserId;

      const md2 = new AppMetaDataService();
      const qh2 = new DwQueryHelper();

      const query2 = md2.EthosUser.CreateQuery();
      const filter2: DwQueryFilter = new DwQueryFilter();
      filter2.Attr = md2.EthosUser.UserId;
      filter2.Value = supId;
      filter2.Op = DwOperator.And;
      filter2.Type = DwFilterType.Equal;
      var supId;
      return this.dataService.executeQuery(query2.AddFilterAnd(filter2)).subscribe(x => {
        const data2 : EthosUserEntity = x[0];
        this.supemail = data2.Email;
      });

    });




  }




}
